import tuner from '../tuner';
import baseState from './baseState';

const state = {
  name: 'idle',
  enter: function () {
    tuner.tune = undefined;
  },
};

export default {
  ...baseState,
  ...state,
};
